import { Component, OnInit } from '@angular/core';
import { userTipeLTI } from '../../../model/lti-launch';
import { LtiLaunchComponent } from '../lti-launch/lti-launch.component';

@Component({
  selector: 'app-launchStudent',
  templateUrl: '../lti-launch/lti-launch.component.html'
})

export class LaunchStudentComponent extends LtiLaunchComponent implements OnInit {

  ngOnInit() {
    this.loadClassConfiguration(userTipeLTI.ESTUDENT);
  }

  startLaunch(): void {
    this.generateParams();
    this.loadInputFields();
    this.submitForm();
  }

}
